import React from 'react'
import Popup from '@Components/Popups/Popup'
import Button from '@Components/Buttons/Button'
import ModalPortal from '@Components/Popups/ModalPortal'

interface GoBackModalProps {
    individualWorkModalIsOpen: boolean
    closeIndividualWorkModal: () => void
    backLink?: string
}

const GoBackModal = (props: GoBackModalProps) => {
    const { individualWorkModalIsOpen, closeIndividualWorkModal, backLink } = props
    return (
        <ModalPortal isOpen={individualWorkModalIsOpen} onClose={closeIndividualWorkModal}>
            <Popup onClose={closeIndividualWorkModal} className="back-confirmation">
                <div className="info-head">
                    <h3>Are you sure you want to go back?</h3>
                    <p>You will lose any unsaved changes.</p>
                </div>
                <div className="search-confirm-popup-content">
                    <div className="buttons-block">
                        <Button mainColor type="secondary" onClick={closeIndividualWorkModal}>
                            No
                        </Button>
                        <Button
                            mainColor
                            className="back"
                            type="primary"
                            linkOnClick={closeIndividualWorkModal}
                            typeLink={!!backLink}
                            linkTo={backLink}
                        >
                            Yes, take me back
                        </Button>
                    </div>
                </div>
            </Popup>
        </ModalPortal>
    )
}

export default GoBackModal
